export default {
  viewBase: {
    'latestresults': '最新结果',
    'heartratetrend': '心率趋势(月)',
    'HealthStatistics': '健康统计(月)',
    'nodata': '暂无数据',
    'poor': '不佳',
    'attention': '注意',
    'good': '良好',
    'averageheartrate': '平均心率',
    'heartratehealthy': '心率健康',
    'pressureindex': '压力指数',
    'fatigueindex': '疲劳指数',
    'yes': '尚可',
    'normal': '正常',
    'overworked': '过劳',
    'relaxed': '轻松',
    'male': '男',
    'female': '女',
    'unknown': '未知',
    'myfamily': '我的家人',
    'Delete': '删除',
    'prompt': '提示',
    'promptcurrent': '确认要解除当前家人关系？',
    'promptaccount': '您的家人是否有盖德系统账号？',
    'promptsystem': '如果您的家人使用手机号注册过盖德健康应用系统，您可以直接绑定手机账号。无论您身在何处，都能随时关注、管理家人健康。',
    'promptrelationship': '选择家人关系',
    'mobilenumber': '手机号码',
    'promptmobile': '请输入手机号码',
    'relationship': '家人关系',
    'bindnow': '立即绑定',
    'promptrelationshipnot': '家人关系未选择',
    'promptmobilenot': '手机号格式错误',
    'bindsuc': '绑定成功',
    'save': '保存',
    'name': '姓名',
    'entername': '请输入姓名',
    'head': '头像',
    'gender': '性别',
    'promptgender': '选择性别',
    'dateofbirth': '生日',
    'select': '请选择',
    'detailedaddress': '详细地址',
    'promptaddress': '请输入详细地址',
    'promptnamenot': '姓名未填写',
    'promptgendernot': '性别未选择',
    'promptdate': '出生日期未选择',
    'addedsuc': '添加成功',
    'nomore': '没有更多了',
    'high': '偏高',
    'low': '偏低',
    'oxygen': '血氧饱和度(%)',
    'flowvelocity': '血流速度',
    'loading': '加载中...',
    'goodtwo': '好',
    'viewECG': '查看心电图',
    'next': '下一步',
    'ECGpicturenot': '心电图图片获取失败',
    'averageheartbeat': '平均心跳',
    'promptfat': '控制三高（高血脂、高血压、高血糖），保持良好习惯并控制体重，有助于维持血管的健康减少心脏多余的做工。',
    'promptpressure': '当处于压力或紧张的状况下，心率会加快，也能引起不规律的现象，建议维持心情的平和，找到适当的舒压方法有助于维持健康。',
    'promptchronic': '可以同时参考慢性疲劳指数，如果慢性疲劳指数是呈现黄灯或红灯，代表压力是长时间累计的，就必须注意。',
    'promptfeel': '避免长时间的熬夜以及过于劳累，适当的休息。如果身体长时间不适，休息也无法改善的话，建议要即使去医院就诊。',
    'height': '身高（cm）',
    'weight': '体重（kg）',
    'promptweight': '请输入体重',
    'promptheight': '请输入身高',
    'uploading': '上传中...',
    'promptcorrectheight': '请填写正确的身高',
    'promptcorrectweight': '请填写正确的体重',
    'promptcorrectbirthday': '请填写正确的生日信息',
    'editsuc': '编辑成功',
    'promptcall': '确认要拨打电话吗？',
    'logout': '退出登录',
    'contactus': '联系我们',
    'privacypolicy': '隐私政策',
    'helpcenter': '帮助中心',
    'instructions': '使用说明',
    'basicinformation': '基本信息',
    'mobilelogin': '手机登录',
    'promptmobilelogin': '请输入手机号',
    'promptcode': '请输入验证码',
    'login': '登录',
    'checkok': '我已认真阅读、理解并同意',
    'promptuser': '《用户服务协议及隐私政策条款》',
    'putcode': '发送验证码',
    'promptcodenote': '验证码格式错误',
    'placepassword': '请输入密码',
    'noaccountnumber': '还没有账号',
    'immediateregistration': '立即注册',
    'passwordfromerror': '密码格式不正确',
    'passwordfromerrorsure': '两次输入密码不一致',
    'placepasswordsix': '请输入至少6位密码',
    'surepassword': '确认密码',
    'password': '密码',
    'adressandcounty': '国家和地区',
    'phoneadress': '手机号归属地',
    'china': '中国',
    'phoneformaterror': '手机号格式错误',
    'codeformaterror': '验证码格式错误',
    'pleasephone': '请输入手机号码',
    'getwechatnot': '获取微信信息失败',
    'sendTo': '已发送至手机',
    'codeInfo': '验证码为 4 位数字',
    promptuserpla: '请同意《用户服务协议及隐私政策条款》'
  }
}

